import dJSON from 'dirty-json';
import {
  animate, stagger, onScroll,
} from 'animejs';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.info-cards';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.info-cards__items').insertAdjacentHTML('beforeend', /* html */ `
          <div class="info-cards__item">
            <div class="image-wrapper">
              <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="content-wrapper">
              <h3 class="title">${item.title}</h3>
              <p class="description">${item.description}</p>
              <a href="${item.buttonLink}" class="btn-custom secondary">${item.buttonText}</a>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Animate
 */
(() => {
  document.querySelectorAll('.animate .info-cards .info-cards__items').forEach((section) => {
    if (!section.children.length) return;
    animate(Array.from(section.children), {
      scale: [0.86, 1],
      opacity: [0, 1],
      duration: 1400,
      ease: 'outBack',
      delay: stagger(500),
      autoplay: onScroll({
        target: section,
        enter: 'bottom center',
        leave: 'bottom-=420 center',
        sync: 0.3,
        debug: false,
      }),
    });
  });
})();
